export default class AddressAction {
    constructor() {
        this.appAddressList = null;
        this.appAddressEdit = null;

        this.editAddress();
        this.saveAddress();
        this.npSearch();
        this.addressList();
    }

    saveAddress() {
        let self = this;
        $('#addressEdit_form, #addressNew_form').each(function () {
            let $initialAddress = $(this).validate({
                highlight: function(element) {
                    $(element).addClass("valid-error").removeClass("success");
                },
                unhighlight: function(element) {
                    $(element).removeClass("valid-error").addClass("success");
                },
                submitHandler: function(form){
                    let action = $(form).attr('action'),
                        formData = new FormData($(form)[0]);

                    $(form).find('button[type="submit"]').prop('disabled', true);
                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        data: formData,
                        dataType: "json",
                    })
                        .then(function (resp) {
                            if(resp.success) {
                                $initialAddress.resetForm();
                                $(form)[0].reset();
                                $(form).closest('.wrap_popup').find('.close').trigger('click');

                                //update list
                                if(resp.data) {
                                    self.appAddressList.setAddress(resp.data);
                                }
                                return true;
                            }
                            alert('Ooops');
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            if(jqXHR.status === 422) {
                                let errorObj = {};
                                if(jqXHR.responseJSON.errors) {
                                    const objErrors = jqXHR.responseJSON.errors;
                                    for (let property in objErrors) {
                                        errorObj[property] = objErrors[property].join(',');
                                    }
                                }
                                $initialAddress.showErrors(errorObj);
                            }
                        })
                        .always(function () {
                            $(form).find('button[type="submit"]').prop('disabled', false);
                        });
                }
            });
        })
    }

    addressList() {
        let self = this;
        this.appAddressList = new Vue({
            el: '#app-address-list',
            delimiters: ['${', '}'],
            data: {
                addresses: [],
            },
            methods: {
                setAddress: function (object) {
                    this.addresses = object;
                },
                setEditAddress: function (index) {
                    self.appAddressEdit.setAddress(this.addresses[index])
                },
                deleteAddress: function (index) {
                    let selfV = this,
                        id = this.addresses[index].id;

                    $.ajax({
                        type: "POST",
                        url: deleteAddressId,
                        data: {id: id},
                        dataType: "json",
                    }).then(function (resp) {
                        if(resp.success) {
                            selfV.addresses.splice(index, 1);
                        }
                    });
                }
            },
            computed: {
                getAddress: function () {
                    return this.addresses;
                },
                getAddressWithoutType4: function () {
                    return this.addresses.filter((item) => {
                        return item.value_array.delivery_type != 4;
                    });
                },
            },
            mounted() {
                let selfV = this;
                if('userAddressObj' in window) {
                    return  selfV.addresses = userAddressObj.list;
                } else {
                    $.ajax({
                        type: "GET",
                        url: getAddressList,
                        dataType: "json",
                    }).then(function (resp) {
                        selfV.addresses = resp;
                    });
                }
            }
        });
    }

    editAddress() {
        this.appAddressEdit = new Vue({
            el: '#app-address-edit',
            delimiters: ['${', '}'],
            data: {
                addresses: {
                    id: 0,
                    value_array: {
                        city: '',
                        delivery_type: '',
                        first_name: '',
                        last_name: '',
                        flat: '',
                        house: '',
                        n_p_city_id: '',
                        n_p_warehouse_id: '',
                        phone: '',
                        post_index: '',
                        street: ''
                    }
                },
            },
            methods: {
                setAddress: function (object) {
                    this.addresses = object;
                }
            },
            computed: {
                getAddress: function () {
                    return this.addresses;
                },
                getAddressWithoutType4: function () {
                    return this.addresses.filter((item) => {
                        return item.value_array.delivery_type != 4;
                    });
                },
            }
        });
    }

    npSearch() {
        let $self = this;
        //Suggest NP
        let timeOut = '';
        $('.suggest_np').keyup(function () {
            let $this = $(this);
            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
                let type = $this.attr('data-suggest'),
                    formData = new FormData();

                formData.append('type', type);
                formData.append('phrase', $this.val());
                if($this.attr('data-city-id')) {
                    formData.append('city_id', $this.attr('data-city-id'));
                }

                $.ajax({
                    type: "POST",
                    url: suggestNPUrl,
                    processData: false,
                    contentType: false,
                    data: formData,
                    dataType: "json",
                })
                    .then(function (resp) {
                        if(resp.success) {
                            $('.drop_down-list .mCustomScrollbar').mCustomScrollbar('destroy');
                            $this.closest('.drop_down').find('.drop_down-list ul').html(resp.data.html);
                            $(".drop_down-list ul").mCustomScrollbar({
                                axis:"y"
                            });
                        }
                    });
            }, 500);
        });

        //Select city & show warehouses
        $('.suggest_np[data-suggest="city"]').parent().siblings('.drop_down-list').on('click', 'li[data-value]:not(.active):not(.info)', function () {
            let $this = $(this);
            setTimeout(function () {
                //TODO: завязано на загальному блоці
                let cityId = $this.closest('.drop_down').find(' > input[name="n_p_city_id"]').val(),
                    $warehouse = $this.closest('.right-col, .wrap-r-col').find('.suggest_np[data-suggest="warehouse"]');

                if($this.val() !== '') {
                    $('input[name="city_ref"]').val($this.closest('.drop_down').find('.drop_down-list li.active').attr('data-ref'));

                    $warehouse.attr('data-city-id', cityId);
                    $warehouse.prop('disabled', false);
                    $warehouse.parent().removeClass('disabled');
                } else {
                    $warehouse.attr('data-city-id', '');
                    $warehouse.prop('disabled', true);
                    $warehouse.parent().addClass('disabled');
                }
                //Reset warehouse
                $warehouse.val('');
                $warehouse.removeClass('full');
                $warehouse.parent().removeClass('valid');
                $warehouse.parent().siblings().find('li[data-value]').remove();
                $warehouse.parent().siblings().find('li.empty').removeAttr('style');
                $warehouse.parent().siblings().find('li.active').removeClass('active');

                // Load warehouses fot selected city
                if(cityId && $warehouse) {
                    $self.npLoadWarehouseByCity(cityId, $warehouse);
                }

            }, 500);
        });
    }

    npLoadWarehouseByCity(cityId, $warehouseEl) {
        let  formData = new FormData();
        formData.append('city_id', cityId);
        $.ajax({
            type: "POST",
            url: npCityWarehouses,
            processData: false,
            contentType: false,
            data: formData,
            dataType: "json",
        })
            .then(function (resp) {
                if(resp.success) {
                    $('.drop_down-list .mCustomScrollbar').mCustomScrollbar('destroy');
                    $warehouseEl.closest('.drop_down').find('.drop_down-list ul').html(resp.data.html);
                    $(".drop_down-list ul").mCustomScrollbar({
                        axis:"y"
                    });
                }
            });
    }
}
